// @core/api/endpoints/authn/list_oauth2_providers.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListOAuth2ProvidersResponse,
} from '../../../types/authn';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/authn';

/**
 * List OAuth2 providers
 * Returns a paginated list of configured OAuth2 identity providers. Supports filtering by provider type and enabled status.
 */
export async function ListOAuth2Providers(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListOAuth2ProvidersResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/providers`;
  const requestOptions = options;
  return client.get<ListOAuth2ProvidersResponse>(requestPath, { ...requestOptions, params });
}
